// // src/pages/Home.js
// import React, { useState, useEffect, useMemo } from "react";
// import { FaPen, FaSpinner } from "react-icons/fa";
// import "../styles/home.css"; // <-- Import the dedicated CSS
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Pagination, Autoplay, Navigation } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/pagination";
// import communitiesData from "../communitiesData.json"; // Import your property data
// import { Link } from 'react-router-dom';
// import { useNavigate } from "react-router-dom";
// import { HtmlDisplay } from '../utils/htmlUtils';
// import MyMapComponent from "../components/MyMapComponent";
// import axios from 'axios';


// const Home = ({ role }) => {
//   return (
//     <div className="home-container">
//       <HeroSection />
//       <CommunitiesMainSection />
//       {/* <MapAutomationSection /> */}
//       <FeaturedCommunities communitiesData={communitiesData} />
//       <DynamicSection role={role} /> {/* Pass the role prop here */}
//       {/* <SuccessStories /> */}
//       <BlogEvents /> 
//       <HelpSection /> 

//     </div>
//   );
// };

// export default Home;

// /* ---------------------------
//    1) HERO SECTION COMPONENT
// ---------------------------- */






// const shuffleArray = (array) => {
//   // Simple Fisher-Yates shuffle
//   const arr = [...array]; 
//   for (let i = arr.length - 1; i > 0; i--) {
//     const j = Math.floor(Math.random() * (i + 1));
//     [arr[i], arr[j]] = [arr[j], arr[i]];
//   }
//   return arr;
// };


// const HeroSection = () => {
//   // 8 slides with unique images, titles, descriptions
//   const slidesData = [
//     {
//       title: "Selling a home in Las Vegas?",
//       description:
//         "I'm here to get you the highest possible price with proven strategies & negotiation.",
//       bgImage: "/images/image1.jpeg",
//     },
//     {
//       title: "Expert Real Estate Guidance",
//       description:
//         "Helping you navigate the real estate market with confidence and expertise.",
//       bgImage: "/images/image2.jpeg",
//     },
//     {
//       title: "Maximize Your Home's Value",
//       description:
//         "Learn how to increase your home's value before listing it on the market.",
//       bgImage: "/images/image3.jpeg",
//     },
//     {
//       title: "Personalized Solutions",
//       description:
//         "We tailor our approach to your unique needs for a stress-free transaction.",
//       bgImage: "/images/image4.jpeg",
//     },
//     {
//       title: "Las Vegas Market Insights",
//       description:
//         "Local knowledge you can trust to make informed decisions and achieve success.",
//       bgImage: "/images/image5.jpeg",
//     },
//     {
//       title: "Trusted Advisors, Proven Results",
//       description:
//         "Decades of experience delivering top-notch service for our clients.",
//       bgImage: "/images/image6.jpeg",
//     },
//     {
//       title: "Buying or Selling? We Can Help",
//       description:
//         "Whether it's your first home or your tenth, we're here to guide you every step of the way.",
//       bgImage: "/images/image7.jpeg",
//     },
//     {
//       title: "Schedule Your Consultation",
//       description:
//         "Ready to take the next step in your real estate journey? Let's talk!",
//       bgImage: "/images/image8.jpeg",
//     },
//   ];

//   // Shuffle once per component mount
//   const slides = useMemo(() => shuffleArray(slidesData), []);

//   return (
//     <div className="relative w-screen h-screen bg-cover bg-center bg-no-repeat">
//       <Swiper
//         modules={[Pagination, Autoplay]}
//         pagination={{ clickable: true }}
//         autoplay={{ delay: 3000, disableOnInteraction: false }}
//         loop={true}
//         className="w-full h-screen"
//       >
//         {slides.map((slide, index) => (
//          <SwiperSlide
//          key={index}
//          style={{
//            backgroundImage: `url('${slide.bgImage}')`,
//            backgroundSize: "cover",
//            backgroundPosition: "center",
//          }}
//          className="relative"
//        >
//          {/* Overlay to darken the background */}
//          <div className="absolute inset-0 bg-black bg-opacity-50 z-0" />
       
//          {/* Content is above the overlay (z-10, etc.) */}
//          <div className="relative z-10 h-full flex flex-col justify-center items-start px-8 md:px-16">
//            <h1 className="text-4xl md:text-5xl font-bold mb-4 home-heading text-white">
//              {slide.title}
//            </h1>
//            <p className="text-lg md:text-xl mb-6 leading-relaxed max-w-2xl home-body text-white">
//              {slide.description}
//            </p>
//            <button
//   onClick={() => {
//     const win = window.open("https://mail.google.com/mail/?view=cm&fs=1&to=BK@BrianKarsh.com&subject=Consultation", "_blank");
//     if (!win) {
//       alert("Popup blocked. Please enable popups for this site.");
//     }
//   }}
//   className="bg-red-600 px-8 py-3 rounded-full text-white font-semibold hover:bg-red-700 transition-colors home-button"
// >
//   Schedule a Consultation
// </button>

//          </div>
//        </SwiperSlide>
       
//         ))}
//       </Swiper>
//     </div>
//   );
// };






// /* -------------------------------
//    2) New FeaturedProperties COMPONENT
// -------------------------------- */



// const FeaturedCommunities = () => {
//   return (
//     <section className="py-16 px-4 md:px-16 bg-gradient-to-b from-gray-50 to-white">
//       <div className="max-w-6xl mx-auto">
//         <div className="flex justify-between items-center mb-10">
//           <h2 className="text-3xl font-bold text-gray-800">Featured Communities</h2>
//           <div className="hidden md:flex space-x-2">
//             <button className="swiper-button-prev bg-white rounded-full p-3 shadow-md hover:bg-gray-100 transition">
//               <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <path d="M15 18l-6-6 6-6" />
//               </svg>
//             </button>
//             <button className="swiper-button-next bg-white rounded-full p-3 shadow-md hover:bg-gray-100 transition">
//               <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <path d="M9 18l6-6-6-6" />
//               </svg>
//             </button>
//           </div>
//         </div>

//         <Swiper
//           modules={[Navigation, Pagination, Autoplay]}
//           pagination={{ clickable: true, dynamicBullets: true }}
//           navigation={{
//             nextEl: '.swiper-button-next',
//             prevEl: '.swiper-button-prev',
//           }}
//           autoplay={{ delay: 3000, disableOnInteraction: false }}
//           loop={true}
//           spaceBetween={30}
//           slidesPerView={3}
//           breakpoints={{
//             320: { slidesPerView: 1, spaceBetween: 20 },
//             640: { slidesPerView: 1, spaceBetween: 20 },
//             768: { slidesPerView: 2, spaceBetween: 30 },
//             1024: { slidesPerView: 3, spaceBetween: 30 },
//           }}
//           effect="slide"
//           speed={800}
//           className="w-full"
//         >
//           {communitiesData.map((property) => (
//             <SwiperSlide key={property.id} className="flex justify-center py-8">
//               <Link to={`/community/${property.id}`} className="w-full h-full bg-white rounded-xl shadow-xl overflow-hidden transform transition-transform hover:scale-105 hover:shadow-2xl">
//                 <div className="relative">
//                   <img
//                     src={property.image}
//                     alt={property.title}
//                     className="w-full h-56 object-cover"
//                   />
//                   <div className="absolute top-4 right-4 bg-blue-600 text-white px-3 py-1 rounded-full text-xs font-semibold">
//                     Featured
//                   </div>
//                 </div>
//                 <div className="p-6">
//                   <h3 className="text-xl font-semibold text-gray-800 mb-2">{property.title}</h3>
//                   <p className="text-gray-600 mb-4 text-sm line-clamp-2">{property.description}</p>
//                   <div className="flex items-center mb-3">
//                     <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
//                     </svg>
//                     <span className="text-sm text-gray-500">{property.location || 'Prime Location'}</span>
//                   </div>
//                   <div className="pt-4 border-t border-gray-100 flex justify-between items-center">
//                     <span className="text-xl font-bold text-blue-600">{property.averageValue}</span>
//                     <span className="bg-blue-50 text-blue-700 text-xs px-3 py-1 rounded-full font-medium">
//                       {property.homesForSale} homes for sale
//                     </span>
//                   </div>
//                 </div>
//               </Link>
//             </SwiperSlide>
//           ))}
//         </Swiper>

//         <div className="mt-8 flex justify-center">
//           <div className="swiper-pagination"></div>
//         </div>
//       </div>
//     </section>
//   );
// };


// /* -------------------------------
//    2) BlogEvents COMPONENT
// -------------------------------- */


// const BlogEvents = () => {
//   const navigate = useNavigate();
//   const [blogPosts, setBlogPosts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     // Fetch blogs from the API
//     const fetchBlogs = async () => {
//       try {
//         setLoading(true);
//         const response = await axios.get('/api/blogs');
        
//         if (response.data && response.data.posts) {
//           // Sort by date if needed (API should already return them sorted)
//           setBlogPosts(response.data.posts);
//         } else {
//           setError('Invalid data format received from server');
//         }
//       } catch (err) {
//         console.error('Error fetching blogs:', err);
//         setError('Failed to load blog posts. Please try again later.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchBlogs();
//   }, []);

//   // Format date for display
//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     if (dateString === "Today" || dateString === "Yesterday" || dateString.includes("days ago")) {
//       return dateString;
//     }
//     const options = { year: 'numeric', month: 'long', day: 'numeric' };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };

//   // Limit displayed posts to the first 3
//   const visiblePosts = blogPosts.slice(0, 3);

//   return (
//     <div className="max-w-6xl px-4 py-12 mx-auto bg-stone-50 rounded-t-xl" style={{marginBottom:'100px'}}>
//       <h1 className="mb-1 text-6xl font-bold text-center blogEvents">
//         Helpful Tips & Guides for Buyers
//       </h1>
//       <br />

//       {loading ? (
//         <div className="flex justify-center py-12">
//           <div className="animate-pulse flex space-x-4">
//             <div className="rounded-full bg-gray-300 h-12 w-12"></div>
//             <div className="flex-1 space-y-4 py-1">
//               <div className="h-4 bg-gray-300 rounded w-3/4"></div>
//               <div className="space-y-2">
//                 <div className="h-4 bg-gray-300 rounded"></div>
//                 <div className="h-4 bg-gray-300 rounded w-5/6"></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       ) : error ? (
//         <div className="text-center py-10">
//           <p className="text-red-500">{error}</p>
//           <button 
//             onClick={() => window.location.reload()} 
//             className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
//           >
//             Try Again
//           </button>
//         </div>
//       ) : (
//         <>
//           {/* Blog Cards Grid */}
//           <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
//             {visiblePosts.length > 0 ? (
//               visiblePosts.map((post) => (
//                 <div 
//                   key={post.id} 
//                   className="overflow-hidden transition-shadow duration-300 bg-white shadow-sm hover:shadow-md cursor-pointer"
//                   onClick={() => {
//                     window.scrollTo(0, 0);
//                     navigate(`/blogs/${post.id}`);
//                   }}
//                 >
//                   <img 
//                     src={post.image} 
//                     alt={post.title}
//                     className="object-cover w-full h-64 rounded-t-xl"
//                   />
//                   <div className="p-6">
//                     <p className="mb-2 text-sm text-gray-500">{formatDate(post.date)}</p>
//                     <h2 className="mb-3 text-xl font-bold leading-tight">{post.title}</h2>
//                     <p className="text-sm text-gray-700">{post.description}</p>
//                   </div>
//                 </div>
//               ))
//             ) : (
//               <div className="col-span-3 text-center py-10">
//                 <p className="text-gray-500">No blog posts available at the moment.</p>
//               </div>
//             )}
//           </div>

//           {/* Show More Button - Redirects to /blogs */}
//           <div className="mt-6 text-center">
//             <button
//               onClick={() => {
//                 window.scrollTo(0, 0); // Scroll to top immediately
//                 setTimeout(() => navigate("/blogs"), 0); // Delay navigation slightly
//               }}
//               className="px-6 py-2 font-semibold text-white transition duration-300 bg-blue-600 rounded-lg hover:bg-blue-700"
//             >
//               Show More
//             </button>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// /* -------------------------------
//    2) SuccessStories COMPONENT
// -------------------------------- */


// /* -----------------------------
//    2) COMMUNITIES MAIN SECTION
// ------------------------------ */


// const parseMoneyValue = (value) => {
//   // Handle values like "$1.71M" or "$493K"
//   if (!value || typeof value !== 'string') return 0;
  
//   const numericPart = value.replace(/[^0-9.]/g, '');
//   const multiplier = value.includes('M') ? 1000000 : value.includes('K') ? 1000 : 1;
  
//   return parseFloat(numericPart) * multiplier;
// };

// const inferCommunityType = (description) => {
//   if (!description) return 'unknown';
  
//   const descLower = description.toLowerCase();
  
//   if (descLower.includes('suburb') || descLower.includes('suburban')) {
//     return 'suburban';
//   }
//   if (descLower.includes('urban') || descLower.includes('downtown')) {
//     return 'urban';
//   }
//   if (descLower.includes('rural') || descLower.includes('mountain')) {
//     return 'rural';
//   }
//   if (descLower.includes('55-and-older') || descLower.includes('retirement') || descLower.includes('age-restricted')) {
//     return 'retirement';
//   }
  
//   return 'unknown';
// };

// const inferAmenities = (description) => {
//   const amenities = [];
//   const descLower = description.toLowerCase();
  
//   if (descLower.includes('pool')) amenities.push('Pool');
//   if (descLower.includes('gym') || descLower.includes('fitness')) amenities.push('Gym');
//   if (descLower.includes('park')) amenities.push('Parks');
//   if (descLower.includes('school')) amenities.push('Schools');
//   if (descLower.includes('shopping') || descLower.includes('mall')) amenities.push('Shopping');
//   if (descLower.includes('transit') || descLower.includes('bus') || descLower.includes('transportation')) amenities.push('Public Transit');
  
//   return amenities;
// };

// /* -----------------------------
//    2) COMMUNITIES MAIN SECTION
// ------------------------------ */
// const CommunitiesMainSection = () => {
//   const [allListings] = useState(communitiesData);
//   const [filteredListings, setFilteredListings] = useState(communitiesData);
//   const [activeFilters, setActiveFilters] = useState({
//     priceRange: '',
//     householdIncome: '',
//     communityType: '',
//     amenities: []
//   });
//   const [filtersApplied, setFiltersApplied] = useState(false);

//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const listingsPerPage = 10;
//   const indexOfLastListing = currentPage * listingsPerPage;
//   const indexOfFirstListing = indexOfLastListing - listingsPerPage;
//   const currentListings = filteredListings.slice(indexOfFirstListing, indexOfLastListing);
//   const totalPages = Math.ceil(filteredListings.length / listingsPerPage);

//   // Apply filters when the Apply button is clicked or when filters are cleared
//   useEffect(() => {
//     if (filtersApplied) {
//       applyFilters();
//     }
//   }, [filtersApplied, activeFilters]);

//   const applyFilters = () => {
//     let filtered = [...allListings];

//     // Apply price range filter
//     if (activeFilters.priceRange) {
//       filtered = filtered.filter(listing => {
//         const price = parseMoneyValue(listing.averageValue);
        
//         switch(activeFilters.priceRange) {
//           case 'low': return price >= 100000 && price < 250000;
//           case 'medium': return price >= 250000 && price < 500000;
//           case 'high': return price >= 500000 && price < 1000000;
//           case 'luxury': return price >= 1000000;
//           default: return true;
//         }
//       });
//     }

//     // Apply household income filter (we'll use this to filter by homes for sale)
//     if (activeFilters.householdIncome) {
//       filtered = filtered.filter(listing => {
//         const homes = listing.homesForSale;
        
//         switch(activeFilters.householdIncome) {
//           case 'low': return homes <= 300;
//           case 'medium': return homes > 300 && homes <= 400;
//           case 'high': return homes > 400;
//           default: return true;
//         }
//       });
//     }

//     // Apply community type filter
//     if (activeFilters.communityType) {
//       filtered = filtered.filter(listing => 
//         inferCommunityType(listing.description) === activeFilters.communityType
//       );
//     }

//     // Apply amenities filter
//     if (activeFilters.amenities.length > 0) {
//       filtered = filtered.filter(listing => {
//         const listingAmenities = inferAmenities(listing.description);
//         // Check if at least one of the selected amenities is in the listing
//         return activeFilters.amenities.some(amenity => listingAmenities.includes(amenity));
//       });
//     }

//     setFilteredListings(filtered);
//     setCurrentPage(1); // Reset to first page after filtering
//     setFiltersApplied(false); // Reset the flag after applying filters
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage((prev) => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage((prev) => prev - 1);
//     }
//   };

//   return (
//     <section className="flex flex-col bg-white mb-16 mt-40 border-2 border-gray-200 rounded-xl shadow-lg mx-4 overflow-hidden">

//       {/* TOP: Filters Bar - Full width above both columns */}
//       {/* <div className="w-full p-6 bg-white">
//         <FiltersBar 
//           activeFilters={activeFilters} 
//           setActiveFilters={setActiveFilters} 
//           setFiltersApplied={setFiltersApplied}
//         />
//       </div> */}

//       {/* BOTTOM: Content columns container with responsive order */}
//       <div className="flex flex-col-reverse md:flex-row h-auto md:h-[calc(100vh-300px)]">

//         {/* LEFT COLUMN: Listings only, scrollable */}
//         <div className="w-full md:w-1/2 overflow-y-auto p-6 pt-0 mt-6 md:mt-0">
//           <Listings
//             listings={currentListings}
//             currentPage={currentPage}
//             totalPages={totalPages}
//             handlePrevPage={handlePrevPage}
//             handleNextPage={handleNextPage}
//             totalResults={filteredListings.length}
//           />
//         </div>

//         {/* RIGHT COLUMN: Map, now displayed first on mobile */}
//         <div className="w-full md:w-1/2 overflow-y-auto p-6 pt-0">
//           <div className="w-full h-[500px] md:h-[600px] bg-gray-100 rounded-lg shadow-sm">
//             <MyMapComponent listings={currentListings} />
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// /* -----------------------------
//    FILTERS BAR COMPONENT
// ------------------------------ */
// const FiltersBar = ({ activeFilters, setActiveFilters, setFiltersApplied }) => {
//   const [isAdvancedFiltersOpen, setIsAdvancedFiltersOpen] = useState(false);

//   const handleFilterChange = (filterName, value) => {
//     setActiveFilters(prev => ({
//       ...prev,
//       [filterName]: value
//     }));
//   };

//   const toggleAdvancedFilters = () => {
//     setIsAdvancedFiltersOpen(!isAdvancedFiltersOpen);
//   };

//   const clearAllFilters = () => {
//     setActiveFilters({
//       priceRange: '',
//       householdIncome: '',
//       communityType: '',
//       amenities: []
//     });
//     setFiltersApplied(true); // Trigger re-filtering with empty filters
//   };

//   const applyFilters = () => {
//     setFiltersApplied(true);
//   };

//   return (
//     <div className="bg-white border border-gray-200 rounded-2xl shadow-xl p-8 max-w-7xl mx-auto" style={{marginBottom:'100px'}}>
//       <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 space-y-4 md:space-y-0">
//         <div className="text-center md:text-left">
//           <h2 className="text-3xl font-extrabold text-gray-900 tracking-tight">
//             Discover Your Ideal Community
//           </h2>
//           <p className="text-gray-500 mt-2 text-sm">
//             Fine-tune your search with our advanced filtering options
//           </p>
//         </div>
        
//         <div className="flex items-center space-x-4">
//           {Object.values(activeFilters).some(filter => 
//             Array.isArray(filter) ? filter.length > 0 : filter !== ''
//           ) && (
//             <button 
//               onClick={clearAllFilters}
//               className="text-red-600 hover:text-red-800 font-semibold flex items-center transition-colors group"
//             >
//               <svg 
//                 xmlns="http://www.w3.org/2000/svg" 
//                 className="h-5 w-5 mr-2 group-hover:rotate-12 transition-transform" 
//                 fill="none" 
//                 viewBox="0 0 24 24" 
//                 stroke="currentColor"
//               >
//                 <path 
//                   strokeLinecap="round" 
//                   strokeLinejoin="round" 
//                   strokeWidth={2} 
//                   d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" 
//                 />
//               </svg>
//               Clear All Filters
//             </button>
//           )}
//           <button 
//             onClick={toggleAdvancedFilters}
//             className="text-blue-600 hover:text-blue-800 font-semibold flex items-center transition-colors group"
//           >
//             <svg 
//               xmlns="http://www.w3.org/2000/svg" 
//               className="h-5 w-5 mr-2 group-hover:rotate-180 transition-transform" 
//               fill="none" 
//               viewBox="0 0 24 24" 
//               stroke="currentColor"
//             >
//               <path 
//                 strokeLinecap="round" 
//                 strokeLinejoin="round" 
//                 strokeWidth={2} 
//                 d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" 
//               />
//             </svg>
//             {isAdvancedFiltersOpen ? 'Hide' : 'Show'} Advanced Filters
//           </button>
//         </div>
//       </div>

//       <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//         {/* Price Range Dropdown */}
//         <div className="relative">
//           <label className="block text-sm font-medium text-gray-700 mb-2">
//             Price Range
//           </label>
//           <div className="relative">
//             <select 
//               value={activeFilters.priceRange}
//               onChange={(e) => handleFilterChange('priceRange', e.target.value)}
//               className="w-full appearance-none border border-gray-300 rounded-lg px-4 py-3 pr-8 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 shadow-sm text-gray-700"
//             >
//               <option value="">All Price Ranges</option>
//               <option value="low">$100k - $250k</option>
//               <option value="medium">$250k - $500k</option>
//               <option value="high">$500k - $1M</option>
//               <option value="luxury">$1M+</option>
//             </select>
//             <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
//               <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
//                 <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
//               </svg>
//             </div>
//           </div>
//         </div>

//         {/* Homes For Sale Dropdown (previously Household Income) */}
//         <div className="relative">
//           <label className="block text-sm font-medium text-gray-700 mb-2">
//             Homes For Sale
//           </label>
//           <div className="relative">
//             <select 
//               value={activeFilters.householdIncome}
//               onChange={(e) => handleFilterChange('householdIncome', e.target.value)}
//               className="w-full appearance-none border border-gray-300 rounded-lg px-4 py-3 pr-8 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 shadow-sm text-gray-700"
//             >
//               <option value="">Any Number</option>
//               <option value="low">Up to 300 homes</option>
//               <option value="medium">301 - 400 homes</option>
//               <option value="high">400+ homes</option>
//             </select>
//             <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
//               <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
//                 <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
//               </svg>
//             </div>
//           </div>
//         </div>

//         {/* Community Type Dropdown */}
//         <div className="relative">
//           <label className="block text-sm font-medium text-gray-700 mb-2">
//             Community Type
//           </label>
//           <div className="relative">
//             <select 
//               value={activeFilters.communityType}
//               onChange={(e) => handleFilterChange('communityType', e.target.value)}
//               className="w-full appearance-none border border-gray-300 rounded-lg px-4 py-3 pr-8 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 shadow-sm text-gray-700"
//             >
//               <option value="">All Types</option>
//               <option value="suburban">Suburban</option>
//               <option value="urban">Urban</option>
//               <option value="rural">Rural</option>
//               <option value="retirement">Retirement</option>
//             </select>
//             <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
//               <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
//                 <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
//               </svg>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Advanced Filters Section */}
//       {isAdvancedFiltersOpen && (
//         <div className="mt-8 pt-6 border-t border-gray-200">
//           <h3 className="text-xl font-semibold text-gray-900 mb-6">
//             Advanced Filters
//           </h3>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-4">
//                 Amenities
//               </label>
//               <div className="flex flex-wrap gap-3">
//                 {['Pool', 'Gym', 'Parks', 'Schools', 'Shopping', 'Public Transit'].map((amenity) => (
//                   <button
//                     key={amenity}
//                     onClick={() => {
//                       const currentAmenities = activeFilters.amenities;
//                       const newAmenities = currentAmenities.includes(amenity)
//                         ? currentAmenities.filter(a => a !== amenity)
//                         : [...currentAmenities, amenity];
//                       handleFilterChange('amenities', newAmenities);
//                     }}
//                     className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ease-in-out transform hover:scale-105 ${
//                       activeFilters.amenities.includes(amenity)
//                         ? 'bg-blue-600 text-white ring-2 ring-blue-500'
//                         : 'bg-gray-100 text-gray-700 hover:bg-blue-100'
//                     }`}
//                   >
//                     {amenity}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Action Buttons */}
//       <div className="mt-8 flex justify-end space-x-4">
//         <button
//           className="px-4 py-2 md:px-6 md:py-3 bg-gray-100 text-gray-800 rounded-lg hover:bg-gray-200 transition-colors font-semibold text-sm md:text-base"
//           onClick={clearAllFilters}
//         >
//           Reset Filters
//         </button>
//         <button
//           className="px-4 py-2 md:px-6 md:py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold shadow-md hover:shadow-lg text-sm md:text-base"
//           onClick={applyFilters}
//         >
//           Apply Filters
//         </button>
//       </div>
//     </div>
//   );
// };

// /* -----------------------------
//    LISTINGS + PAGINATION
// ------------------------------ */
// const Listings = ({
//   listings,
//   currentPage,
//   totalPages,
//   handlePrevPage,
//   handleNextPage,
//   totalResults
// }) => {
//   return (
//     <>
//       {/* Results count */}
//       <div className="mb-4 text-gray-600">
//         Showing {listings.length} of {totalResults} communities
//       </div>
      
//       {/* Listing Cards */}
//       <div className="space-y-6">
//         {listings.length > 0 ? (
//           listings.map((listing) => (
//             <ListingCard key={listing.id} listing={listing} />
//           ))
//         ) : (
//           <div className="p-8 text-center bg-gray-50 rounded-lg border border-gray-200">
//             <h3 className="text-xl font-semibold text-gray-700 mb-2">No Communities Found</h3>
//             <p className="text-gray-500">
//               Try adjusting your filters to see more results.
//             </p>
//           </div>
//         )}
//       </div>

//       {/* Pagination Controls */}
//       {listings.length > 0 && (
//         <div className="flex items-center justify-center gap-4 mt-8">
//           <button
//             onClick={handlePrevPage}
//             className="px-4 py-2 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 disabled:opacity-50 transition-colors font-medium"
//             disabled={currentPage === 1}
//           >
//             Prev
//           </button>
//           <span className="text-gray-700">
//             Page {currentPage} of {totalPages}
//           </span>
//           <button
//             onClick={handleNextPage}
//             className="px-4 py-2 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 disabled:opacity-50 transition-colors font-medium"
//             disabled={currentPage === totalPages}
//           >
//             Next
//           </button>
//         </div>
//       )}
//     </>
//   );
// };

// /* -----------------------------
//    LISTING CARD COMPONENT
// ------------------------------ */
// const ListingCard = ({ listing }) => {
//   return (
//     <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow border border-gray-200 flex flex-col md:flex-row">
//       {/* Listing Image with overlay for quick stats */}
//       <div className="relative md:w-1/3">
//         <img
//           src={listing.image}
//           alt={listing.title}
//           className="w-full h-48 md:h-full object-cover"
//         />
//         <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
//           <div className="flex justify-between text-white text-sm font-medium">
//             {/* <span>${listing.averageValue}</span>
//             <span>{listing.homesForSale} Homes</span> */}
//           </div>
//         </div>
//       </div>

//       {/* Listing Info */}
//       <div className="flex-1 p-5">
//         <div className="flex justify-between items-start">
//           <div>
//             <h3 className="font-bold text-xl text-gray-800 hover:text-blue-600 transition-colors">
//               {listing.title}
//             </h3>
//           </div>
//           <button className="text-gray-400 hover:text-red-500 transition-colors">
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               className="h-6 w-6"
//               fill="none"
//               viewBox="0 0 24 24"
//               stroke="currentColor"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
//               />
//             </svg>
//           </button>
//         </div>

//         <p className="text-gray-600 my-3 line-clamp-3">{listing.description}</p>

//         <div className="flex flex-wrap gap-4 mt-4">
//           <div className="flex items-center text-sm text-gray-700">
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               className="h-4 w-4 mr-1 text-gray-500"
//               fill="none"
//               viewBox="0 0 24 24"
//               stroke="currentColor"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
//               />
//             </svg>
//             <span>
//               Avg. Value: <strong>{listing.averageValue}</strong>
//             </span>
//           </div>

//           <div className="flex items-center text-sm text-gray-700">
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               className="h-4 w-4 mr-1 text-gray-500"
//               fill="none"
//               viewBox="0 0 24 24"
//               stroke="currentColor"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
//               />
//             </svg>
//             <span>
//               For Sale: <strong>{listing.homesForSale} homes</strong>
//             </span>
//           </div>
          
//           {/* Added: Display Community Type */}
//           <div className="flex items-center text-sm text-gray-700">
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               className="h-4 w-4 mr-1 text-gray-500"
//               fill="none"
//               viewBox="0 0 24 24"
//               stroke="currentColor"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
//               />
//             </svg>
//             <span>
//               Type: <strong className="capitalize">{inferCommunityType(listing.description)}</strong>
//             </span>
//           </div>
//         </div>

//         <div className="mt-5 pt-4 border-t border-gray-100 flex justify-between items-center">
//           <span className="text-sm text-gray-500">Last updated: 3 days ago</span>

//           {/* Link to dynamic route using listing.id */}
//           <Link
//             to={`/community/${listing.id}`}
//             className="px-4 py-2 bg-blue-50 text-blue-600 rounded-md hover:bg-blue-100 transition-colors font-medium text-sm"
//           >
//             View Details
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };
// /* -------------------------------
//    3) HelpSection COMPONENT
// -------------------------------- */

// const HelpSection = () => {
//   return (
//     <section className="py-16 px-4 md:px-16 bg-gray-50">
//       <div className="max-w-6xl mx-auto">
//         <h2 className="text-3xl font-bold text-gray-800 mb-12 text-center">
//           How We Can Help
//         </h2>
//         {/* Use a responsive grid: 1 column on mobile and 2 columns on md+ */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//           {/* Buy a home Card */}
//           <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden">
//             <div className="p-8">
//               <div className="mb-6 flex justify-center">
//                 <div className="w-24 h-24 bg-orange-100 rounded-full flex items-center justify-center">
//                   {/* Replace with your Buy image */}
//                   <img
//                     src="/images/buy.png"
//                     alt="Buy a home"
//                     className="w-20 h-20 object-contain"
//                   />
//                 </div>
//               </div>
//               <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">
//                 Buy a home
//               </h3>
//               <p className="text-gray-600 mb-8 text-center">
//                 A real estate agent can provide you with a clear breakdown of costs so that you can avoid surprise expenses.
//               </p>
//               <div className="flex justify-center">
//                 <a
//                   href="/buy"
//                   className="inline-block px-6 py-3 bg-white border border-blue-600 text-blue-600 font-medium rounded-full hover:bg-blue-50 transition duration-300"
//                 >
//                   Find a local agent
//                 </a>
//               </div>
//             </div>
//           </div>

//           {/* Sell a home Card */}
//           <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden">
//             <div className="p-8">
//               <div className="mb-6 flex justify-center">
//                 <div className="w-24 h-24 bg-orange-100 rounded-full flex items-center justify-center">
//                   {/* Replace with your Sell image */}
//                   <img
//                     src="/images/sale.png"
//                     alt="Sell a home"
//                     className="w-20 h-20 object-contain"
//                   />
//                 </div>
//               </div>
//               <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">
//                 Sell a home
//               </h3>
//               <p className="text-gray-600 mb-8 text-center">
//                 No matter what path you take to sell your home, we can help you navigate a successful sale.
//               </p>
//               <div className="flex justify-center">
//                 <a
//                   href="/sell"
//                   className="inline-block px-6 py-3 bg-white border border-blue-600 text-blue-600 font-medium rounded-full hover:bg-blue-50 transition duration-300"
//                 >
//                   See your options
//                 </a>
//               </div>
//             </div>
//           </div>
          
//         </div>
//       </div>
//     </section>
//   );
// };






// /* -------------------------------
//    2) DYNAMIC SECTION COMPONENT
// -------------------------------- */


// // ======= DISPLAY STATE (visible content) =======

// const DynamicSection = ({ role }) => {
//   const [heading, setHeading] = useState("");
//   const [subheading, setSubheading] = useState("");
//   const [description, setDescription] = useState("");
//   const [images, setImages] = useState([]);

//   // ======= EDIT STATE (form fields) =======
//   const [editHeading, setEditHeading] = useState("");
//   const [editSubheading, setEditSubheading] = useState("");
//   const [editDescription, setEditDescription] = useState("");
//   const [editImages, setEditImages] = useState([]);

//   const [isUploading, setIsUploading] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState(0);


//   // Slideshow index
//   const [currentIndex, setCurrentIndex] = useState(0);

//   // Show/Hide the edit form
//   const [showEditForm, setShowEditForm] = useState(false);

//   // ======= Load from localStorage on mount =======
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await fetch("/api/get_dynamic", {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//           },
//         });

//         const data = await response.json();
//         if (response.ok) {
//           setHeading(data.heading);
//           setSubheading(data.subheading);
//           setDescription(data.description);
//           setImages(data.images);
//         } else {
//           console.error("Failed to fetch data:", data.message);
//         }
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };

//     fetchData();
//   }, []);

//   // ======= Continuous Slideshow =======
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
//     }, 5000);

//     return () => clearInterval(interval);
//   }, [images]);

//   // ======= Handle Edit Form =======
//   const handlePenClick = () => {
//     setEditHeading(heading);
//     setEditSubheading(subheading);
//     setEditDescription(description);
//     setEditImages([]);
//     setShowEditForm(true);
//   };

//   // Save the data to the server
//   const handleSave = async (e) => {
//     e.preventDefault();

//     if (isUploading) return;

//     // Prepare data to send
//     const dataToSave = {
//       heading: editHeading || "",  // Default to empty string if falsy
//       subheading: editSubheading || "",
//       description: editDescription || "",
//       images: editImages.length > 0 ? editImages : images,
//     };
//     console.log("Sending data to backend:", dataToSave);

//     try {
//       const response = await fetch("/api/save_dynamic_section", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//         body: JSON.stringify(dataToSave),
//       });

//       const data = await response.json();
//       if (response.ok) {
//         console.log("Data saved successfully");
//         setShowEditForm(false);
//       } else {
//         console.error("Failed to save data:", data.message);
//       }
//     } catch (error) {
//       console.error("Error saving data:", error);
//     }
//   };

//   // Handle file uploads (for new images only)
//   const handleFileChange = async (e) => {
//     const files = e.target.files;
//     if (!files) return;

//     const fileArray = Array.from(files);

//     setIsUploading(true);
//     setUploadProgress(0);
//     setEditImages([]);

//     const uploadedUrls = [];

//     for (let [index, file] of fileArray.entries()) {
//       const formData = new FormData();
//       formData.append("file", file);
//       formData.append("upload_preset", "Brian_Karsh");

//       // Upload to Cloudinary
//       try {
//         const response = await fetch("https://api.cloudinary.com/v1_1/dyglrkcfq/image/upload", {
//           method: "POST",
//           body: formData,
//         });

//         const result = await response.json();
//         if (response.ok) {
//           uploadedUrls.push(result.secure_url);
//           setEditImages((prev) => [...prev, result.secure_url]);

//                     // Update progress
//           setUploadProgress(Math.round(((index + 1) / fileArray.length) * 100));

//         } else {
//           console.error("Error uploading to Cloudinary:", result.message);
//           setIsUploading(false);

//         }
//       } catch (error) {
//         console.error("Error uploading image:", error);
//         setIsUploading(false);
//         return;
//       }
//     }
//     setIsUploading(false);
//     setUploadProgress(100);

//   };

  

//   // Format the description text with paragraphs
//   const formattedDescription = description
//     .split("\n\n")
//     .map((paragraph, index) => (
//       <p key={index} className="text-gray-700 leading-relaxed home-body justify-text mb-4">
//         {paragraph}
//       </p>
//     ));

//   return (
//     <section
//     className="
//       py-16 px-4 md:px-16
//       bg-white
//       relative
//       mt-10 md:mt-40
//     "
//   >
  
//       {role === "owner" && (
//         <button onClick={handlePenClick} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700">
//           <FaPen size={18} />
//         </button>
//       )}

//       <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-start gap-12">
//         {/* Left side: Text content */}
//         <div data-aos="fade-right" className="md:w-1/2">
//   <h2 className="text-4xl font-bold text-gray-800 dynamic-heading mb-10">
//     {heading}
//   </h2>
//   <h3 className="text-2xl font-semibold mb-4 text-gray-800">
//     {subheading}
//   </h3>
//   <div className="space-y-2">{formattedDescription}</div>
  
//   {/* Wrap the button in a div for extra margin and centering */}
//   <div className="mt-4 md:mt-8 flex justify-center">
//       <button
//       onClick={() => {
//     const win = window.open("https://mail.google.com/mail/?view=cm&fs=1&to=BK@BrianKarsh.com&subject=Consultation", "_blank");
//     if (!win) {
//       alert("Popup blocked. Please enable popups for this site.");
//     }
//   }}
//   className="bg-red-600 px-8 py-3 rounded-full text-white font-semibold hover:bg-red-700 transition-colors home-button"
// >
//   Schedule a Consultation
// </button>

//   </div>
// </div>

//         {/* Right side: Slideshow */}
//         <div data-aos="zoom-in" className="md:w-1/2 flex justify-center items-center">
//           <div className="fade-slide-container">
//             {images.map((img, i) => (
//               <img key={`${img}-${i}`} src={img} alt="Slideshow" className={`fade-slide ${i === currentIndex ? "active" : ""}`} />
//             ))}
//           </div>
//         </div>
//       </div>

//     {/* Edit Form (Modal) */}
// {showEditForm && (
//   <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
//     <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-xl max-w-md w-full relative animate-fadeIn">
//       <div className="flex justify-between items-center mb-6">
//         <h2 className="text-xl font-bold dark:text-white">Edit Section</h2>
//         <button 
//           onClick={() => setShowEditForm(false)}
//           className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
//         >
//           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//             <line x1="18" y1="6" x2="6" y2="18"></line>
//             <line x1="6" y1="6" x2="18" y2="18"></line>
//           </svg>
//         </button>
//       </div>

//       <form onSubmit={handleSave} className="space-y-5">
//         <div>
//           <label className="block font-medium text-gray-700 dark:text-gray-300 mb-2">Heading</label>
//           <input
//             type="text"
//             className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
//             value={editHeading}
//             onChange={(e) => setEditHeading(e.target.value)}
//             placeholder="Enter section heading"
//           />
//         </div>

//         <div>
//           <label className="block font-medium text-gray-700 dark:text-gray-300 mb-2">Subheading</label>
//           <input
//             type="text"
//             className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
//             value={editSubheading}
//             onChange={(e) => setEditSubheading(e.target.value)}
//             placeholder="Enter section subheading"
//           />
//         </div>

//         <div>
//           <label className="block font-medium text-gray-700 dark:text-gray-300 mb-2">Description</label>
//           <textarea
//             rows={6}
//             className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white resize-none"
//             value={editDescription}
//             onChange={(e) => setEditDescription(e.target.value)}
//             placeholder="Enter section description"
//           />
//         </div>

//         <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-md">
//           <label className="block font-medium text-gray-700 dark:text-gray-300 mb-2">Replace Images</label>
//           <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md p-4 text-center hover:bg-gray-100 dark:hover:bg-gray-600 transition duration-150 cursor-pointer">
//           <input 
//             type="file" 
//             multiple 
//             accept="image/*" 
//             onChange={handleFileChange}
//             className="hidden" 
//             id="image-upload"
//             disabled={isUploading}
//           />
//             <label htmlFor="image-upload" className={`cursor-pointer ${isUploading ? 'opacity-50' : ''}`}>
//               {isUploading ? (
//                 <div className="flex flex-col items-center">
//                   <FaSpinner className="animate-spin h-12 w-12 text-blue-500 mb-2" />
//                   <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
//                     Uploading... {uploadProgress}%
//                   </span>
//                 </div>
//               ) : (
//                 <>
//                   <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
//                     <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4h-8m-12 0H8m16 0a4 4 0 01-4-4v-4m8 0h8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//                   </svg>
//                   <span className="mt-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
//                     Click to upload images
//                   </span>
//                   <span className="mt-1 block text-xs text-gray-500 dark:text-gray-400">
//                     Select one or more images to replace the entire slideshow
//                   </span>
//                 </>
//               )}
//             </label>
//           </div>
//         </div>

//         <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200 dark:border-gray-700 mt-6">
//         <button 
//             type="submit" 
//             disabled={isUploading}
//             className={`px-4 py-2 rounded-md text-white transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 
//               ${isUploading 
//                 ? 'bg-gray-400 cursor-not-allowed' 
//                 : 'bg-blue-600 hover:bg-blue-700'
//               }`}
//           >
//             {isUploading ? 'Uploading...' : 'Save Changes'}
//           </button>
//         </div>
//       </form>
//     </div>
//   </div>
// )}
//     </section>
//   );
// };







// /* ---------------------------
//    3) MAP AUTOMATION SECTION
// ---------------------------- */
// // const MapAutomationSection = () => {
// //   return (
// //     <section className="px-4 py-16 bg-white md:px-16">
// //       <div className="max-w-6xl mx-auto">
// //         <h2
// //           data-aos="fade-right"
// //           className="mb-8 text-3xl font-bold text-gray-800"
// //         >
// //           Maps
// //         </h2>
// //         {/* Placeholder space for future map automation */}
// //         <MyMapComponent />
// //       </div>
// //     </section>
// //   );
// // };


// // const MapAutomationSection = () => {
// //   const [htmlContent, setHtmlContent] = useState('<div>Loading map...</div>');

// //   useEffect(() => {
// //     // Only fetch map content if not on mobile (improves performance)
// //     if (window.innerWidth >= 768) {
// //       const loadMap = async () => {
// //         try {
// //           // Fetch from the backend route
// //           const response = await fetch('/api/map_content');
// //           if (response.ok) {
// //             const content = await response.text();
// //             setHtmlContent(content);
// //           } else {
// //             console.error('Failed to load map, status:', response.status);
// //             setHtmlContent('<div>Failed to load map. Please check console.</div>');
// //           }
// //         } catch (err) {
// //           console.error('Error loading map:', err);
// //           setHtmlContent(`<div>Error: ${err.message}</div>`);
// //         }
// //       };

// //       loadMap();
// //     }
// //   }, []);

// //   return (
// //     <section className="px-4 py-16 bg-white md:px-16">
// //       <div className="max-w-6xl mx-auto">
// //         <h2 
// //           className="mb-8 text-3xl font-bold text-gray-800"
// //           data-aos="fade-right"
// //         >
// //           Map
// //         </h2>

// //         {/* Mobile View - Card with message */}
// //         <div className="block md:hidden">
// //           <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 text-center shadow-md">
// //             <div className="mb-4 flex justify-center">
// //               <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
// //                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
// //               </svg>
// //             </div>
// //             <h3 className="text-xl font-semibold text-gray-800 mb-2">Desktop Experience Recommended</h3>
// //             <p className="text-gray-600 mb-4">
// //               Our interactive property map is optimized for larger screens. 
// //               For the best experience, please view this feature on a tablet, laptop, or desktop device.
// //             </p>
// //             <div className="text-sm text-gray-500">
// //               <p>Meanwhile, you can browse our communities below!</p>
// //             </div>
// //           </div>
// //         </div>

// //         {/* Desktop View - Map */}
// //         <div className="hidden md:block">
// //           <div className="overflow-hidden border rounded-lg" style={{ minHeight: '500px' }}>
// //             <HtmlDisplay htmlContent={htmlContent} />
// //           </div>
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };



















// src/pages/Home.js
import React, { useState, useEffect, useMemo } from "react";
import { FaPen, FaSpinner } from "react-icons/fa";
import "../styles/home.css"; // <-- Import the dedicated CSS
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import communitiesData from "../communitiesData.json"; // Import your property data
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { HtmlDisplay } from '../utils/htmlUtils';
import MyMapComponent from "../components/MyMapComponent";
import axios from 'axios';


const Home = ({ role }) => {
  return (
    <div className="home-container">
      <HeroSection />
      <CommunitiesMainSection role={role} />
      {/* <MapAutomationSection /> */}
      <FeaturedCommunities communitiesData={communitiesData} />
      <DynamicSection role={role} /> {/* Pass the role prop here */}
      {/* <SuccessStories /> */}
      <BlogEvents /> 
      <HelpSection /> 

    </div>
  );
};

export default Home;

/* ---------------------------
   1) HERO SECTION COMPONENT
---------------------------- */






const shuffleArray = (array) => {
  // Simple Fisher-Yates shuffle
  const arr = [...array]; 
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
};


const HeroSection = () => {
  // 8 slides with unique images, titles, descriptions
  const slidesData = [
    {
      title: "Selling a home in Las Vegas?",
      description:
        "I'm here to get you the highest possible price with proven strategies & negotiation.",
      bgImage: "/images/image1.jpeg",
    },
    {
      title: "Expert Real Estate Guidance",
      description:
        "Helping you navigate the real estate market with confidence and expertise.",
      bgImage: "/images/image2.jpeg",
    },
    {
      title: "Maximize Your Home's Value",
      description:
        "Learn how to increase your home's value before listing it on the market.",
      bgImage: "/images/image3.jpeg",
    },
    {
      title: "Personalized Solutions",
      description:
        "We tailor our approach to your unique needs for a stress-free transaction.",
      bgImage: "/images/image4.jpeg",
    },
    {
      title: "Las Vegas Market Insights",
      description:
        "Local knowledge you can trust to make informed decisions and achieve success.",
      bgImage: "/images/image5.jpeg",
    },
    {
      title: "Trusted Advisors, Proven Results",
      description:
        "Decades of experience delivering top-notch service for our clients.",
      bgImage: "/images/image6.jpeg",
    },
    {
      title: "Buying or Selling? We Can Help",
      description:
        "Whether it's your first home or your tenth, we're here to guide you every step of the way.",
      bgImage: "/images/image7.jpeg",
    },
    {
      title: "Schedule Your Consultation",
      description:
        "Ready to take the next step in your real estate journey? Let's talk!",
      bgImage: "/images/image8.jpeg",
    },
  ];

  // Shuffle once per component mount
  const slides = useMemo(() => shuffleArray(slidesData), []);

  return (
    <div className="relative w-screen h-screen bg-cover bg-center bg-no-repeat">
      <Swiper
        modules={[Pagination, Autoplay]}
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop={true}
        className="w-full h-screen"
      >
        {slides.map((slide, index) => (
         <SwiperSlide
         key={index}
         style={{
           backgroundImage: `url('${slide.bgImage}')`,
           backgroundSize: "cover",
           backgroundPosition: "center",
         }}
         className="relative"
       >
         {/* Overlay to darken the background */}
         <div className="absolute inset-0 bg-black bg-opacity-50 z-0" />
       
         {/* Content is above the overlay (z-10, etc.) */}
         <div className="relative z-10 h-full flex flex-col justify-center items-start px-8 md:px-16">
           <h1 className="text-4xl md:text-5xl font-bold mb-4 home-heading text-white">
             {slide.title}
           </h1>
           <p className="text-lg md:text-xl mb-6 leading-relaxed max-w-2xl home-body text-white">
             {slide.description}
           </p>
           <button
  onClick={() => {
    const win = window.open("https://mail.google.com/mail/?view=cm&fs=1&to=KarshB1@hotmail.com&subject=Consultation", "_blank");
    if (!win) {
      alert("Popup blocked. Please enable popups for this site.");
    }
  }}
  className="bg-red-600 px-8 py-3 rounded-full text-white font-semibold hover:bg-red-700 transition-colors home-button"
>
  Schedule a Consultation
</button>

         </div>
       </SwiperSlide>
       
        ))}
      </Swiper>
    </div>
  );
};






/* -------------------------------
   2) New FeaturedProperties COMPONENT
-------------------------------- */



const FeaturedCommunities = () => {
  return (
    <section className="py-16 px-4 md:px-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto">
        <div className="flex justify-between items-center mb-10">
          <h2 className="text-3xl font-bold text-gray-800">Featured Communities</h2>
          <div className="hidden md:flex space-x-2">
            <button className="swiper-button-prev bg-white rounded-full p-3 shadow-md hover:bg-gray-100 transition">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </button>
            <button className="swiper-button-next bg-white rounded-full p-3 shadow-md hover:bg-gray-100 transition">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 18l6-6-6-6" />
              </svg>
            </button>
          </div>
        </div>

        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          pagination={{ clickable: true, dynamicBullets: true }}
          navigation={{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          loop={true}
          spaceBetween={30}
          slidesPerView={3}
          breakpoints={{
            320: { slidesPerView: 1, spaceBetween: 20 },
            640: { slidesPerView: 1, spaceBetween: 20 },
            768: { slidesPerView: 2, spaceBetween: 30 },
            1024: { slidesPerView: 3, spaceBetween: 30 },
          }}
          effect="slide"
          speed={800}
          className="w-full"
        >
          {communitiesData.map((property) => (
            <SwiperSlide key={property.id} className="flex justify-center py-8">
              <Link to={`/community/${property.id}`} className="w-full h-full bg-white rounded-xl shadow-xl overflow-hidden transform transition-transform hover:scale-105 hover:shadow-2xl">
                <div className="relative">
                  <img
                    src={property.image}
                    alt={property.title}
                    className="w-full h-56 object-cover"
                  />
                  <div className="absolute top-4 right-4 bg-blue-600 text-white px-3 py-1 rounded-full text-xs font-semibold">
                    Featured
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">{property.title}</h3>
                  <p className="text-gray-600 mb-4 text-sm line-clamp-2">{property.description}</p>
                  <div className="flex items-center mb-3">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    <span className="text-sm text-gray-500">{property.location || 'Prime Location'}</span>
                  </div>
                  <div className="pt-4 border-t border-gray-100 flex justify-between items-center">
                    <span className="text-xl font-bold text-blue-600">{property.averageValue}</span>
                    <span className="bg-blue-50 text-blue-700 text-xs px-3 py-1 rounded-full font-medium">
                      {property.homesForSale} homes for sale
                    </span>
                  </div>
                </div>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="mt-8 flex justify-center">
          <div className="swiper-pagination"></div>
        </div>
      </div>
    </section>
  );
};


/* -------------------------------
   2) BlogEvents COMPONENT
-------------------------------- */


const BlogEvents = () => {
  const navigate = useNavigate();
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const backendUrl = 'https://python-backend-68898252993.us-central1.run.app';

  useEffect(() => {
    // Fetch blogs from the API
    const fetchBlogs = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${backendUrl}/api/blogs` );
        
        if (response.data && response.data.posts) {
          // Sort by date if needed (API should already return them sorted)
          setBlogPosts(response.data.posts);
        } else {
          setError('Invalid data format received from server');
        }
      } catch (err) {
        console.error('Error fetching blogs:', err);
        setError('Failed to load blog posts. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return "";
    if (dateString === "Today" || dateString === "Yesterday" || dateString.includes("days ago")) {
      return dateString;
    }
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  // Limit displayed posts to the first 3
  const visiblePosts = blogPosts.slice(0, 3);

  return (
    <div className="max-w-6xl px-4 py-12 mx-auto bg-stone-50 rounded-t-xl" style={{marginBottom:'100px'}}>
      <h1 className="mb-1 text-6xl font-bold text-center blogEvents">
        Helpful Tips & Guides for Buyers
      </h1>
      <br />

      {loading ? (
        <div className="flex justify-center py-12">
          <div className="animate-pulse flex space-x-4">
            <div className="rounded-full bg-gray-300 h-12 w-12"></div>
            <div className="flex-1 space-y-4 py-1">
              <div className="h-4 bg-gray-300 rounded w-3/4"></div>
              <div className="space-y-2">
                <div className="h-4 bg-gray-300 rounded"></div>
                <div className="h-4 bg-gray-300 rounded w-5/6"></div>
              </div>
            </div>
          </div>
        </div>
      ) : error ? (
        <div className="text-center py-10">
          <p className="text-red-500">{error}</p>
          <button 
            onClick={() => window.location.reload()} 
            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            Try Again
          </button>
        </div>
      ) : (
        <>
          {/* Blog Cards Grid */}
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
            {visiblePosts.length > 0 ? (
              visiblePosts.map((post) => (
                <div 
                  key={post.id} 
                  className="overflow-hidden transition-shadow duration-300 bg-white shadow-sm hover:shadow-md cursor-pointer"
                  onClick={() => {
                    window.scrollTo(0, 0);
                    navigate(`/blogs/${post.id}`);
                  }}
                >
                  <img 
                    src={post.image} 
                    alt={post.title}
                    className="object-cover w-full h-64 rounded-t-xl"
                  />
                  <div className="p-6">
                    <p className="mb-2 text-sm text-gray-500">{formatDate(post.date)}</p>
                    <h2 className="mb-3 text-xl font-bold leading-tight">{post.title}</h2>
                    <p className="text-sm text-gray-700">{post.description}</p>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-span-3 text-center py-10">
                <p className="text-gray-500">No blog posts available at the moment.</p>
              </div>
            )}
          </div>

          {/* Show More Button - Redirects to /blogs */}
          <div className="mt-6 text-center">
            <button
              onClick={() => {
                window.scrollTo(0, 0); // Scroll to top immediately
                setTimeout(() => navigate("/blogs"), 0); // Delay navigation slightly
              }}
              className="px-6 py-2 font-semibold text-white transition duration-300 bg-blue-600 rounded-lg hover:bg-blue-700"
            >
              Show More
            </button>
          </div>
        </>
      )}
    </div>
  );
};



/* -----------------------------
   2) COMMUNITIES MAIN SECTION
------------------------------ */


// Keep these helper functions as they're still useful
const parseMoneyValue = (value) => {
  if (!value || typeof value !== 'string') return 0;
  
  const numericPart = value.replace(/[^0-9.]/g, '');
  const multiplier = value.includes('M') ? 1000000 : value.includes('K') ? 1000 : 1;
  
  return parseFloat(numericPart) * multiplier;
};

const inferCommunityType = (description) => {
  if (!description) return 'unknown';
  
  const descLower = description.toLowerCase();
  
  if (descLower.includes('suburb') || descLower.includes('suburban')) {
    return 'suburban';
  }
  if (descLower.includes('urban') || descLower.includes('downtown')) {
    return 'urban';
  }
  if (descLower.includes('rural') || descLower.includes('mountain')) {
    return 'rural';
  }
  if (descLower.includes('55-and-older') || descLower.includes('retirement') || descLower.includes('age-restricted')) {
    return 'retirement';
  }
  
  return 'unknown';
};

const inferAmenities = (description) => {
  const amenities = [];
  const descLower = description.toLowerCase();
  
  if (descLower.includes('pool')) amenities.push('Pool');
  if (descLower.includes('gym') || descLower.includes('fitness')) amenities.push('Gym');
  if (descLower.includes('park')) amenities.push('Parks');
  if (descLower.includes('school')) amenities.push('Schools');
  if (descLower.includes('shopping') || descLower.includes('mall')) amenities.push('Shopping');
  if (descLower.includes('transit') || descLower.includes('bus') || descLower.includes('transportation')) amenities.push('Public Transit');
  
  return amenities;
};

/* -----------------------------
   2) COMMUNITIES MAIN SECTION
------------------------------ */
const CommunitiesMainSection =  ({ role }) => {
  const [allListings, setAllListings] = useState([]);
  const [filteredListings, setFilteredListings] = useState([]);
  const [activeFilters, setActiveFilters] = useState({
    priceRange: '',
    householdIncome: '',
    communityType: '',
    amenities: []
  });
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const listingsPerPage = 10;
  const indexOfLastListing = currentPage * listingsPerPage;
  const indexOfFirstListing = indexOfLastListing - listingsPerPage;
  const currentListings = filteredListings.slice(indexOfFirstListing, indexOfLastListing);
  const totalPages = Math.ceil(filteredListings.length / listingsPerPage);
  const backendUrl = 'https://python-backend-68898252993.us-central1.run.app';

  // Fetch communities from API
  useEffect(() => {
    const fetchCommunities = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${backendUrl}/api/communities`);
        setAllListings(response.data);
        setFilteredListings(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching community data:', err);
        setError('Failed to load communities. Please try again later.');
        setLoading(false);
      }
    };

    fetchCommunities();
  }, []);

  // Apply filters when the Apply button is clicked or when filters are cleared
  useEffect(() => {
    if (filtersApplied) {
      applyFilters();
    }
  }, [filtersApplied, activeFilters]);

  const applyFilters = () => {
    let filtered = [...allListings];

    // Apply price range filter
    if (activeFilters.priceRange) {
      filtered = filtered.filter(listing => {
        const price = parseMoneyValue(listing.averageValue);
        
        switch(activeFilters.priceRange) {
          case 'low': return price >= 100000 && price < 250000;
          case 'medium': return price >= 250000 && price < 500000;
          case 'high': return price >= 500000 && price < 1000000;
          case 'luxury': return price >= 1000000;
          default: return true;
        }
      });
    }

    // Apply household income filter (we'll use this to filter by homes for sale)
    if (activeFilters.householdIncome) {
      filtered = filtered.filter(listing => {
        const homes = listing.homesForSale;
        
        switch(activeFilters.householdIncome) {
          case 'low': return homes <= 300;
          case 'medium': return homes > 300 && homes <= 400;
          case 'high': return homes > 400;
          default: return true;
        }
      });
    }

    // Apply community type filter
    if (activeFilters.communityType) {
      filtered = filtered.filter(listing => 
        inferCommunityType(listing.description) === activeFilters.communityType
      );
    }

    // Apply amenities filter
    if (activeFilters.amenities.length > 0) {
      filtered = filtered.filter(listing => {
        const listingAmenities = inferAmenities(listing.description);
        // Check if at least one of the selected amenities is in the listing
        return activeFilters.amenities.some(amenity => listingAmenities.includes(amenity));
      });
    }

    setFilteredListings(filtered);
    setCurrentPage(1); // Reset to first page after filtering
    setFiltersApplied(false); // Reset the flag after applying filters
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  if (loading) return <div className="flex justify-center items-center h-96"><div className="loader">Loading...</div></div>;
  
  if (error) return <div className="p-4 text-red-500 bg-red-50 rounded-md">{error}</div>;

  return (
    <section className="flex flex-col bg-white mb-16 mt-40 border-2 border-gray-200 rounded-xl shadow-lg mx-4 overflow-hidden">
      {/* TOP: Filters Bar - Full width above both columns */}
      {/* <div className="w-full p-6 bg-white">
        <FiltersBar 
          activeFilters={activeFilters} 
          setActiveFilters={setActiveFilters} 
          setFiltersApplied={setFiltersApplied}
        />
      </div> */}

      {/* BOTTOM: Content columns container with responsive order */}
      <div className="flex flex-col-reverse md:flex-row h-auto md:h-[calc(120vh-300px)]">

        {/* LEFT COLUMN: Listings only, scrollable */}
        <div className="w-full md:w-1/2 overflow-y-auto p-6 pt-0 mt-6 md:mt-0">
          <Listings
            listings={currentListings}
            currentPage={currentPage}
            totalPages={totalPages}
            handlePrevPage={handlePrevPage}
            handleNextPage={handleNextPage}
            totalResults={filteredListings.length}
          />
        </div>

        {/* RIGHT COLUMN: Map, now displayed first on mobile */}
        <div className="w-full md:w-1/2 overflow-y-auto p-6 pt-0">
          <div className="w-full h-[500px] md:h-[600px] bg-gray-100 rounded-lg shadow-sm">
            <MyMapComponent listings={currentListings} />
          </div>
        </div>
      </div>
      
      {/* Add New Community Button */}
      <div className="w-full p-6 flex justify-center">


      {role === "owner" && (

        <button 
          onClick={() => window.location.href = '/add-community'} 
          className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-full shadow-lg transition-colors duration-200 flex items-center"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
          </svg>
          Add New Community
        </button>
      )}


        
      </div>
    </section>
  );
};

/* -----------------------------
   LISTINGS + PAGINATION
------------------------------ */
const Listings = ({
  listings,
  currentPage,
  totalPages,
  handlePrevPage,
  handleNextPage,
  totalResults
}) => {
  return (
    <>
      {/* Results count */}
      <div className="mb-4 text-gray-600">
        Showing {listings.length} of {totalResults} communities
      </div>
      
      {/* Listing Cards */}
      <div className="space-y-6">
        {listings.length > 0 ? (
          listings.map((listing) => (
            <ListingCard key={listing.id} listing={listing} />
          ))
        ) : (
          <div className="p-8 text-center bg-gray-50 rounded-lg border border-gray-200">
            <h3 className="text-xl font-semibold text-gray-700 mb-2">No Communities Found</h3>
            <p className="text-gray-500">
              Try adjusting your filters to see more results.
            </p>
          </div>
        )}
      </div>

      {/* Pagination Controls */}
      {listings.length > 0 && (
        <div className="flex items-center justify-center gap-4 mt-8">
          <button
            onClick={handlePrevPage}
            className="px-4 py-2 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 disabled:opacity-50 transition-colors font-medium"
            disabled={currentPage === 1}
          >
            Prev
          </button>
          <span className="text-gray-700">
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={handleNextPage}
            className="px-4 py-2 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 disabled:opacity-50 transition-colors font-medium"
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}
    </>
  );
};

// Updated Listing Card Component
const ListingCard = ({ listing }) => {
  return (
    <div className="flex flex-col md:flex-row border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow duration-200">
      {/* Image */}
      <div className="w-full md:w-1/3 h-48 md:h-auto">
        <img 
          src={listing.image || 'https://via.placeholder.com/300x200'} 
          alt={listing.title} 
          className="w-full h-full object-cover"
        />
      </div>
      
      {/* Content */}
      <div className="w-full md:w-2/3 p-4 flex flex-col justify-between">
        <div>
          <h3 className="text-xl font-semibold text-gray-800 mb-2">{listing.title}</h3>
          <p className="text-gray-600 mb-4 line-clamp-2">{listing.description}</p>
          
          {/* Stats */}
          <div className="grid grid-cols-2 gap-2 mb-4">
            <div>
              <span className="text-gray-500 text-sm">Average Value</span>
              <p className="font-medium">{listing.averageValue}</p>
            </div>
            <div>
              <span className="text-gray-500 text-sm">Homes Available</span>
              <p className="font-medium">{listing.homesForSale}</p>
            </div>
          </div>
        </div>
        
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-500">
            {inferCommunityType(listing.description) !== 'unknown' ? 
              inferCommunityType(listing.description).charAt(0).toUpperCase() + 
              inferCommunityType(listing.description).slice(1) : 
              'Community'}
          </span>
          <a 
            href={`/community/${listing.id}`}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors text-sm font-medium"
          >
            View Details
          </a>
        </div>
      </div>
    </div>
  );
};

/* -----------------------------
   LISTING CARD COMPONENT

/* -------------------------------
   3) HelpSection COMPONENT
-------------------------------- */

const HelpSection = () => {
  return (
    <section className="py-16 px-4 md:px-16 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold text-gray-800 mb-12 text-center">
          How We Can Help
        </h2>
        {/* Use a responsive grid: 1 column on mobile and 2 columns on md+ */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Buy a home Card */}
          <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden">
            <div className="p-8">
              <div className="mb-6 flex justify-center">
                <div className="w-24 h-24 bg-orange-100 rounded-full flex items-center justify-center">
                  {/* Replace with your Buy image */}
                  <img
                    src="/images/buy.png"
                    alt="Buy a home"
                    className="w-20 h-20 object-contain"
                  />
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">
                Buy a home
              </h3>
              <p className="text-gray-600 mb-8 text-center">
                A real estate agent can provide you with a clear breakdown of costs so that you can avoid surprise expenses.
              </p>
              <div className="flex justify-center">
                <a
                  href="/buy"
                  className="inline-block px-6 py-3 bg-white border border-blue-600 text-blue-600 font-medium rounded-full hover:bg-blue-50 transition duration-300"
                >
                  Find a local agent
                </a>
              </div>
            </div>
          </div>

          {/* Sell a home Card */}
          <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden">
            <div className="p-8">
              <div className="mb-6 flex justify-center">
                <div className="w-24 h-24 bg-orange-100 rounded-full flex items-center justify-center">
                  {/* Replace with your Sell image */}
                  <img
                    src="/images/sale.png"
                    alt="Sell a home"
                    className="w-20 h-20 object-contain"
                  />
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">
                Sell a home
              </h3>
              <p className="text-gray-600 mb-8 text-center">
                No matter what path you take to sell your home, we can help you navigate a successful sale.
              </p>
              <div className="flex justify-center">
                <a
                  href="/sell"
                  className="inline-block px-6 py-3 bg-white border border-blue-600 text-blue-600 font-medium rounded-full hover:bg-blue-50 transition duration-300"
                >
                  See your options
                </a>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
};






/* -------------------------------
   2) DYNAMIC SECTION COMPONENT
-------------------------------- */


// ======= DISPLAY STATE (visible content) =======
const DynamicSection = ({ role }) => {
  const [heading, setHeading] = useState("");
  const [subheading, setSubheading] = useState("");
  const [description, setDescription] = useState("");
  const [images, setImages] = useState([]);

  // ======= EDIT STATE (form fields) =======
  const [editHeading, setEditHeading] = useState("");
  const [editSubheading, setEditSubheading] = useState("");
  const [editDescription, setEditDescription] = useState("");
  const [editImages, setEditImages] = useState([]);

  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  // Slideshow index
  const [currentIndex, setCurrentIndex] = useState(0);

  // Show/Hide the edit form
  const [showEditForm, setShowEditForm] = useState(false);
  const backendUrl = 'https://python-backend-68898252993.us-central1.run.app';

  // ======= Load from localStorage on mount =======
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${backendUrl}/api/get_dynamic` , {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        const data = await response.json();
        if (response.ok) {
          setHeading(data.heading);
          setSubheading(data.subheading);
          setDescription(data.description);
          setImages(data.images);
        } else {
          console.error("Failed to fetch data:", data.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // ======= Continuous Slideshow =======
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % (images.length || 1));
    }, 5000);

    return () => clearInterval(interval);
  }, [images]);

  // ======= Handle Edit Form =======
  const handlePenClick = () => {
    setEditHeading(heading);
    setEditSubheading(subheading);
    setEditDescription(description);
    setEditImages([]);
    setShowEditForm(true);
  };

  // Save the data to the server
  const handleSave = async (e) => {
    e.preventDefault();

    if (isUploading) return;

    // Prepare data to send
    const dataToSave = {
      heading: editHeading || "",  // Default to empty string if falsy
      subheading: editSubheading || "",
      description: editDescription || "",
      images: editImages.length > 0 ? editImages : images,
    };
    console.log("Sending data to backend:", dataToSave);

    try {
      const response = await fetch(`${backendUrl}/api/save_dynamic_section` , {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(dataToSave),
      });

      const data = await response.json();
      if (response.ok) {
        console.log("Data saved successfully");
        // Update the main state with edited values
        setHeading(editHeading);
        setSubheading(editSubheading);
        setDescription(editDescription);
        if (editImages.length > 0) {
          setImages(editImages);
        }
        setShowEditForm(false);
      } else {
        console.error("Failed to save data:", data.message);
      }
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  // Handle file uploads (for new images only)
  const handleFileChange = async (e) => {
    const files = e.target.files;
    if (!files) return;

    const fileArray = Array.from(files);

    setIsUploading(true);
    setUploadProgress(0);
    setEditImages([]);

    const uploadedUrls = [];

    for (let [index, file] of fileArray.entries()) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", "Brian_Karsh");

      // Upload to Cloudinary
      try {
        const response = await fetch("https://api.cloudinary.com/v1_1/dyglrkcfq/image/upload", {
          method: "POST",
          body: formData,
        });

        const result = await response.json();
        if (response.ok) {
          uploadedUrls.push(result.secure_url);
          setEditImages((prev) => [...prev, result.secure_url]);

          // Update progress
          setUploadProgress(Math.round(((index + 1) / fileArray.length) * 100));

        } else {
          console.error("Error uploading to Cloudinary:", result.message);
          setIsUploading(false);
        }
      } catch (error) {
        console.error("Error uploading image:", error);
        setIsUploading(false);
        return;
      }
    }
    setIsUploading(false);
    setUploadProgress(100);
  };

  // Remove an image from the edit preview
  const handleRemoveImage = (indexToRemove) => {
    setEditImages(editImages.filter((_, index) => index !== indexToRemove));
  };

  // Format the description text with paragraphs
  const formattedDescription = description
    .split("\n\n")
    .map((paragraph, index) => (
      <p key={index} className="text-gray-700 leading-relaxed home-body justify-text mb-4">
        {paragraph}
      </p>
    ));

  return (
    <section
      className="
        py-16 px-4 md:px-16
        bg-white
        relative
        mt-10 md:mt-40
      "
    >
      {role === "owner" && (
        <button onClick={handlePenClick} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700">
          <FaPen size={18} />
        </button>
      )}

      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-start gap-12">
        {/* Left side: Text content */}
        <div data-aos="fade-right" className="md:w-1/2">
          <h2 className="text-4xl font-bold text-gray-800 dynamic-heading mb-10">
            {heading}
          </h2>
          <h3 className="text-2xl font-semibold mb-4 text-gray-800">
            {subheading}
          </h3>
          <div className="space-y-2">{formattedDescription}</div>
          
          {/* Wrap the button in a div for extra margin and centering */}
          <div className="mt-4 md:mt-8 flex justify-center">
            <button
              onClick={() => {
                const win = window.open("https://mail.google.com/mail/?view=cm&fs=1&to=KarshB1@hotmail.com&subject=Consultation", "_blank");
                if (!win) {
                  alert("Popup blocked. Please enable popups for this site.");
                }
              }}
              className="bg-red-600 px-8 py-3 rounded-full text-white font-semibold hover:bg-red-700 transition-colors home-button"
            >
              Schedule a Consultation
            </button>
          </div>
        </div>

        {/* Right side: Slideshow */}
        <div data-aos="zoom-in" className="md:w-1/2 flex justify-center items-center">
          <div className="fade-slide-container">
            {images.length > 0 ? (
              images.map((img, i) => (
                <img 
                  key={`${img}-${i}`} 
                  src={img} 
                  alt="Slideshow" 
                  className={`fade-slide ${i === currentIndex ? "active" : ""}`} 
                />
              ))
            ) : (
              <div className="fade-slide active flex items-center justify-center bg-gray-100 rounded-lg h-80 w-full">
                <p className="text-gray-400">No images available</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Edit Form (Modal) */}
      {showEditForm && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-xl max-w-lg w-full relative animate-fadeIn overflow-y-auto max-h-[90vh]">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-bold dark:text-white">Edit Section</h2>
              <button 
                onClick={() => setShowEditForm(false)}
                className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>

            <form onSubmit={handleSave} className="space-y-5">
              <div>
                <label className="block font-medium text-gray-700 dark:text-gray-300 mb-2">Heading</label>
                <input
                  type="text"
                  className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                  value={editHeading}
                  onChange={(e) => setEditHeading(e.target.value)}
                  placeholder="Enter section heading"
                />
              </div>

              <div>
                <label className="block font-medium text-gray-700 dark:text-gray-300 mb-2">Subheading</label>
                <input
                  type="text"
                  className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                  value={editSubheading}
                  onChange={(e) => setEditSubheading(e.target.value)}
                  placeholder="Enter section subheading"
                />
              </div>

              <div>
                <label className="block font-medium text-gray-700 dark:text-gray-300 mb-2">Description</label>
                <textarea
                  rows={6}
                  className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white resize-none"
                  value={editDescription}
                  onChange={(e) => setEditDescription(e.target.value)}
                  placeholder="Enter section description"
                />
              </div>

              <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-md">
                <label className="block font-medium text-gray-700 dark:text-gray-300 mb-2">Replace Images</label>
                <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md p-4 text-center hover:bg-gray-100 dark:hover:bg-gray-600 transition duration-150 cursor-pointer">
                  <input 
                    type="file" 
                    multiple 
                    accept="image/*" 
                    onChange={handleFileChange}
                    className="hidden" 
                    id="image-upload"
                    disabled={isUploading}
                  />
                  <label htmlFor="image-upload" className={`cursor-pointer ${isUploading ? 'opacity-50' : ''}`}>
                    {isUploading ? (
                      <div className="flex flex-col items-center">
                        <FaSpinner className="animate-spin h-12 w-12 text-blue-500 mb-2" />
                        <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                          Uploading... {uploadProgress}%
                        </span>
                      </div>
                    ) : (
                      <>
                        <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                          <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4h-8m-12 0H8m16 0a4 4 0 01-4-4v-4m8 0h8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <span className="mt-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
                          Click to upload images
                        </span>
                        <span className="mt-1 block text-xs text-gray-500 dark:text-gray-400">
                          Select one or more images to replace the entire slideshow
                        </span>
                      </>
                    )}
                  </label>
                </div>
              </div>

              {/* Image Preview Section */}
              {editImages.length > 0 && (
                <div className="mt-4">
                  <h3 className="font-medium text-gray-700 dark:text-gray-300 mb-2">Uploaded Images Preview</h3>
                  <div className="grid grid-cols-2 gap-3">
                    {editImages.map((url, index) => (
                      <div key={index} className="relative rounded-md overflow-hidden border border-gray-200 group">
                        <img 
                          src={url} 
                          alt={`Uploaded image ${index + 1}`} 
                          className="w-full h-32 object-cover" 
                        />
                        <button
                          type="button"
                          onClick={() => handleRemoveImage(index)}
                          className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                          </svg>
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200 dark:border-gray-700 mt-6">
                <button 
                  type="submit" 
                  disabled={isUploading}
                  className={`px-4 py-2 rounded-md text-white transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 
                    ${isUploading 
                      ? 'bg-gray-400 cursor-not-allowed' 
                      : 'bg-blue-600 hover:bg-blue-700'
                    }`}
                >
                  {isUploading ? 'Uploading...' : 'Save Changes'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </section>
  );
};




/* ---------------------------
   3) MAP AUTOMATION SECTION
---------------------------- */
// const MapAutomationSection = () => {
//   return (
//     <section className="px-4 py-16 bg-white md:px-16">
//       <div className="max-w-6xl mx-auto">
//         <h2
//           data-aos="fade-right"
//           className="mb-8 text-3xl font-bold text-gray-800"
//         >
//           Maps
//         </h2>
//         {/* Placeholder space for future map automation */}
//         <MyMapComponent />
//       </div>
//     </section>
//   );
// };


// const MapAutomationSection = () => {
//   const [htmlContent, setHtmlContent] = useState('<div>Loading map...</div>');

//   useEffect(() => {
//     // Only fetch map content if not on mobile (improves performance)
//     if (window.innerWidth >= 768) {
//       const loadMap = async () => {
//         try {
//           // Fetch from the backend route
//           const response = await fetch('/api/map_content');
//           if (response.ok) {
//             const content = await response.text();
//             setHtmlContent(content);
//           } else {
//             console.error('Failed to load map, status:', response.status);
//             setHtmlContent('<div>Failed to load map. Please check console.</div>');
//           }
//         } catch (err) {
//           console.error('Error loading map:', err);
//           setHtmlContent(`<div>Error: ${err.message}</div>`);
//         }
//       };

//       loadMap();
//     }
//   }, []);

//   return (
//     <section className="px-4 py-16 bg-white md:px-16">
//       <div className="max-w-6xl mx-auto">
//         <h2 
//           className="mb-8 text-3xl font-bold text-gray-800"
//           data-aos="fade-right"
//         >
//           Map
//         </h2>

//         {/* Mobile View - Card with message */}
//         <div className="block md:hidden">
//           <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 text-center shadow-md">
//             <div className="mb-4 flex justify-center">
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
//               </svg>
//             </div>
//             <h3 className="text-xl font-semibold text-gray-800 mb-2">Desktop Experience Recommended</h3>
//             <p className="text-gray-600 mb-4">
//               Our interactive property map is optimized for larger screens. 
//               For the best experience, please view this feature on a tablet, laptop, or desktop device.
//             </p>
//             <div className="text-sm text-gray-500">
//               <p>Meanwhile, you can browse our communities below!</p>
//             </div>
//           </div>
//         </div>

//         {/* Desktop View - Map */}
//         <div className="hidden md:block">
//           <div className="overflow-hidden border rounded-lg" style={{ minHeight: '500px' }}>
//             <HtmlDisplay htmlContent={htmlContent} />
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

